"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "spotwork-bg" };
const _hoisted_2 = {
    key: 0,
    class: "spotworker-accordion"
};
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "font-xsm" }, "読み込み中...", -1 /* HOISTED */);
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "loading" }, null, -1 /* HOISTED */);
const _hoisted_5 = [
    _hoisted_3,
    _hoisted_4
];
const _hoisted_6 = {
    key: 1,
    class: "font-xsm"
};
const _hoisted_7 = ["colspan"];
const vue_3 = require("vue");
const useSpotWorkerSummary_1 = require("./summaryPage/composable/useSpotWorkerSummary");
const types_1 = require("./types");
const SpotWorkerModalWrapper_vue_1 = __importDefault(require("./summaryPage/components/SpotWorkerModalWrapper.vue"));
const SummaryTableSpotworkerRow_vue_1 = __importDefault(require("./summaryPage/components/SummaryTableSpotworkerRow.vue"));
const ShiftModal_vue_1 = __importDefault(require("./summaryPage/components/ShiftModal.vue"));
const provider_1 = require("./provider");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SpotWorkerSummaryApp',
    props: {
        dates: {},
        stats: {},
        showMemoSummary: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const branch = (0, vue_3.inject)("activeBranch", { id: 0, name: "", groupId: 0, ownerIds: [], employeeIds: [], address: "", groupName: "" });
        const roleStore = (0, vue_3.inject)("roleStore");
        const summaryComposable = (0, useSpotWorkerSummary_1.useSpotWorkerSummary)();
        const selectedShiftId = (0, vue_3.ref)(0);
        const spotShiftStore = (0, vue_3.inject)(provider_1.spotShiftStoreKey);
        const spotWorkerStore = (0, vue_3.inject)(provider_1.spotWorkerStoreKey);
        const roles = (0, vue_3.computed)(() => {
            return roleStore?.query({ isOrRole: true, excludeOrRole: true }) || [];
        });
        const isLoading = (0, vue_3.computed)(() => {
            return spotShiftStore?.state.fetching || spotWorkerStore?.state.fetching;
        });
        const startDateComputed = (0, vue_3.computed)(() => {
            let out = new Date();
            const d = props.dates[0];
            if (d) {
                out = new Date(d);
            }
            return out;
        });
        const endDateComputed = (0, vue_3.computed)(() => {
            let out = new Date();
            const d = props.dates[props.dates.length - 1];
            if (d) {
                out = new Date(d);
            }
            return out;
        });
        const isAccordionOpen = (0, vue_3.ref)(false);
        (0, vue_3.watch)(() => [startDateComputed.value, endDateComputed.value, branch.id], ([startDate, endDate, branchId]) => {
            try {
                if (!branchId) {
                    return;
                }
                summaryComposable.setDates(startDate, endDate);
                summaryComposable.setBranchId(branchId);
            }
            catch (err) {
                alert(err);
            }
        }, { immediate: true });
        function handleSelectedShift(shiftId) {
            selectedShiftId.value = shiftId;
        }
        function handleShiftModalClose() {
            selectedShiftId.value = 0;
        }
        function handleToggleAccordion() {
            if (isLoading.value) {
                return;
            }
            isAccordionOpen.value = !isAccordionOpen.value;
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (selectedShiftId.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ShiftModal_vue_1.default, {
                        key: 0,
                        selectedShiftId: selectedShiftId.value,
                        onCloseShiftModal: handleShiftModalClose
                    }, null, 8 /* PROPS */, ["selectedShiftId"]))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createVNode)(SpotWorkerModalWrapper_vue_1.default),
                (0, vue_2.createElementVNode)("tr", _hoisted_1, [
                    (0, vue_2.createElementVNode)("td", {
                        onClick: handleToggleAccordion,
                        class: "c-hand spotwork-bg spotworker-accordion"
                    }, [
                        (0, vue_2.createElementVNode)("i", {
                            class: (0, vue_2.normalizeClass)(["zmdi zmdi-chevron-right zmdi-hc-lg arrow", { expanded: isAccordionOpen.value }])
                        }, null, 2 /* CLASS */),
                        (isLoading.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, _hoisted_5))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, "単発スタッフ"))
                    ]),
                    (0, vue_2.createElementVNode)("td", {
                        colspan: _ctx.dates.length + Object.values(props.stats || {}).length + roles.value.length,
                        class: "spotwork-bg"
                    }, null, 8 /* PROPS */, _hoisted_7)
                ]),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(summaryComposable).data.value.spotWorkers, (spotWorker, i) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SummaryTableSpotworkerRow_vue_1.default, {
                        key: spotWorker.id,
                        dates: _ctx.dates,
                        spotShifts: (0, vue_2.unref)(summaryComposable).data.value[(0, vue_2.unref)(types_1.SpotShiftKey).CLAIMED][(0, vue_2.unref)(branch).id]?.[spotWorker.id],
                        showDataCells: true,
                        spotworker: spotWorker,
                        stats: _ctx.stats,
                        "show-memo-summary": _ctx.showMemoSummary,
                        onSelectedShift: handleSelectedShift,
                        "is-open": isAccordionOpen.value
                    }, null, 8 /* PROPS */, ["dates", "spotShifts", "spotworker", "stats", "show-memo-summary", "is-open"]));
                }), 128 /* KEYED_FRAGMENT */)),
                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(summaryComposable).data.value.tempSpotWorkers, (spotWorker, i) => {
                    return ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(SummaryTableSpotworkerRow_vue_1.default, {
                        key: spotWorker.id,
                        dates: _ctx.dates,
                        spotShifts: (0, vue_2.unref)(summaryComposable).data.value[(0, vue_2.unref)(types_1.SpotShiftKey).UNCLAIMED][(0, vue_2.unref)(branch).id]?.[spotWorker.tempId],
                        showDataCells: true,
                        spotworker: spotWorker,
                        stats: _ctx.stats,
                        "show-memo-summary": _ctx.showMemoSummary,
                        onSelectedShift: handleSelectedShift,
                        "is-open": isAccordionOpen.value,
                        "is-last-row": (0, vue_2.unref)(summaryComposable).data.value.tempSpotWorkers.length === i + 1,
                        "is-temp-row": true
                    }, null, 8 /* PROPS */, ["dates", "spotShifts", "spotworker", "stats", "show-memo-summary", "is-open", "is-last-row"]));
                }), 128 /* KEYED_FRAGMENT */))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
